import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISingleIdParams } from '../../../spacesPlatform/utils/actionParams';
import { IPredictiveModelActions } from '../types/IPredictiveModelActions';

export class GetPredictiveModelActionsRequest extends Request<ISingleIdParams, IPredictiveModelActions> {
  constructor(id: string) {
    super('getPredictiveModelActions', { id: id });
  }
}
